import { css } from '@emotion/react';
import {
  forceAbsoluteStrapiUrl,
  Shape,
  ShapeLayout,
  Wrapper,
  WrapperProps,
} from '@scorenco/components';

type ShapesWrapperProps = WrapperProps & {
  images?: ({ url?: string | null } | undefined)[];
};

export const ShapesWrapper = ({
  children,
  images,
  ...rest
}: ShapesWrapperProps) => {
  return (
    <Wrapper
      css={(theme) => css`
        position: relative;
        height: 30rem;
        display: flex;
        justify-content: center;
        align-items: center;
        ${theme.breakpoints.down('md')} {
          overflow-x: clip;
        }

        @keyframes wait {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 0;
          }
        }

        @keyframes moveUp {
          0% {
            opacity: 0;
            transform: translate(-100px, 100px);
          }
          100% {
            opacity: 1;
            transform: translate(0, 0);
          }
        }

        @keyframes moveDown {
          0% {
            opacity: 0;
            transform: translate(100px, -100px);
          }
          100% {
            opacity: 1;
            transform: translate(0, 0);
          }
        }
      `}
      noMargin={true}
      {...rest}
    >
      <ShapeLayout
        variant="alt"
        css={css`
          position: absolute;
          left: calc(-100vw * 10 / 100);
          top: -30%;
          width: 25%;
          min-width: 12rem;
          z-index: 0;
        `}
      >
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[0]?.url ?? undefined)}
          sx={{ animation: 'wait 0.2s, moveUp 0.5s ease-in-out 0.2s' }}
        />
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[1]?.url ?? undefined)}
          sx={{ animation: 'wait 0.4s, moveUp 0.5s ease-in-out 0.4s' }}
        />
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[2]?.url ?? undefined)}
          sx={{ animation: 'wait 0.6s, moveUp 0.5s ease-in-out 0.6s' }}
        />
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[3]?.url ?? undefined)}
          sx={{ animation: 'wait 0.8s, moveUp 0.5s ease-in-out 0.8s' }}
        />
      </ShapeLayout>

      <ShapeLayout
        css={css`
          position: absolute;
          right: calc(-100vw * 10 / 100);
          bottom: -15%;
          width: 25%;
          min-width: 12rem;
          z-index: 1;
        `}
      >
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[4]?.url ?? undefined)}
          sx={{ animation: 'wait 0.2s, moveUp 0.5s ease-in-out 0.2s' }}
        />
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[5]?.url ?? undefined)}
          sx={{ animation: 'wait 0.4s, moveUp 0.5s ease-in-out 0.4s' }}
        />
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[6]?.url ?? undefined)}
          sx={{ animation: 'wait 0.6s, moveUp 0.5s ease-in-out 0.6s' }}
        />
        <Shape
          src={forceAbsoluteStrapiUrl(images?.[7]?.url ?? undefined)}
          sx={{ animation: 'wait 0.8s, moveUp 0.5s ease-in-out 0.8s' }}
        />
      </ShapeLayout>

      <div
        css={css`
          z-index: 1;
        `}
      >
        {children}
      </div>
    </Wrapper>
  );
};
